import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

/*
Render due to lead version
  1: portal lead
  2: NA/AB lead
  3: DO Lead
  4: VCB/ARG Lead
 */
const useVersion = () => {
  const [version, setVersion] = useState(4);
  let { leadId } = useParams();
  const userBank = useSelector((state) => state?.lookup?.bank);
  let leadBank = useSelector((state) => state?.leads?.byIds?.[leadId]?.bank);

  useEffect(() => {
    let version;
    let bank = leadId ? leadBank : userBank;
    switch (bank) {
      case 'VCB':
        version = 4;
        break;
      case 'NAB':
      case 'ABB':
      case 'AGR':
        version = 2;
        break;
      default:
        version = 4;
    }
    setVersion(version);
  }, [leadId, userBank, leadBank]);

  return version;
};

export default useVersion;
